import { AreaSection } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/measure'
import React from 'react'
import { IfOverflowType, ReferenceArea } from 'recharts'

interface IWarnAreaOptions {
  color?: string
  colorMap?: Record<number | string, string>
  opacity?: number
  overflow?: IfOverflowType
  xAxisId?: string
  yAxisId?: string
}

export const WAREA_EMPTY_COLOR = '#EEE'

/**
 * @deprecated Use `TimeRangeColoredArea` widget component instead
 * TODO: Remove this function after migration to the new widget component
 */
const reduceWarnAreas = (warnPoints: AreaSection[], options?: IWarnAreaOptions) => {
  if (warnPoints && warnPoints.length > 0) {
    return warnPoints.map((e: any, i) => {
      const color = options?.colorMap?.[e.value] || options?.color || WAREA_EMPTY_COLOR
      return (
        <ReferenceArea
          ifOverflow={options?.overflow || 'visible'}
          key={i + e.x1}
          x1={e.x1}
          x2={e.x2}
          stroke={color}
          fill={color}
          strokeWidth={1}
          strokeLinejoin={'miter'}
          fillOpacity={options?.opacity ?? 1}
          strokeOpacity={options?.opacity ?? 1}
          yAxisId={options?.yAxisId}
          xAxisId={options?.xAxisId}
        />
      )
    })
  }

  return null
}

/**
 * @deprecated Use {@link getMeasureValueSegments} instead
 * TODO: Remove this function after migration to the new widget component
 */
const getAreaSections = (dataSrc: any, key: string) => {
  const out: AreaSection[] = []

  let index = 0
  while (index < dataSrc.length) {
    const current = dataSrc[index]
    for (let i = index; i < dataSrc.length; i++) {
      const next = dataSrc[i]
      if (i === dataSrc.length - 1) {
        out.push({
          x1: current.time,
          x2: next.time,
          y1: 0,
          y2: 100,
          value: current[key],
        })
        index = i
      }
      if (current[key] !== next[key] && next[key] !== undefined && next[key] !== null) {
        out.push({
          x1: current.time,
          x2: next.time,
          y1: 0,
          y2: 100,
          value: current[key],
        })
        index = i - 1
        break
      }
    }
    index++
  }

  return out
}

const joinSubsequentAreaSections = (list: AreaSection[]): AreaSection[] => {
  const joinedList: AreaSection[] = []
  for (let i = 0; i < list.length; i++) {
    const el = list[i]
    while (el.x2 === list[i + 1]?.x1 && i < list.length) {
      el.x2 = list[i + 1].x2
      i++
    }
    joinedList.push(el)
  }
  return joinedList
}

export { reduceWarnAreas, getAreaSections, joinSubsequentAreaSections }
